import { NgModule } from '@angular/core'
import { CommonModule } from '@angular/common'
import { ProgrammesResultsComponent } from './programmes-results.component'
import { SharedModule } from '../shared/shared.module'
import { InfiniteScrollModule } from 'ngx-infinite-scroll';
import { ResultViewComponent } from './result-view/result-view.component'



@NgModule({
  declarations: [ProgrammesResultsComponent, ResultViewComponent],
  imports: [
    CommonModule,
    SharedModule,
    InfiniteScrollModule
  ],
  exports: [ProgrammesResultsComponent]
})
export class ProgrammesResultsModule { }
